import { Injectable, inject } from '@angular/core';
import { WsAccountDetails } from '@model/ftf-api.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '@service/api.service';
import { LoggerService } from '@service/logger.service';
import { SettingsService } from '@service/settings.service';
import { catchError, map, mergeMap, of } from 'rxjs';

import * as AccountActions from '../actions/account.actions';

@Injectable()
export class AccountEffects {
  private actions$ = inject(Actions);
  private apiService = inject(ApiService);
  private settingsService = inject(SettingsService);
  private loggerService = inject(LoggerService);


  loadAccountDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountActions.loadAccountDetails),
      mergeMap(() => {
        this.loggerService.debug('[AccountEffects] Effect triggered: Load Account Details');
        return this.apiService.findUserAccountInfo().pipe(
          map((accountDetails: WsAccountDetails) => {
            const parsedUrl = this.settingsService.getParsedBaseUrl();
            const CLIENT_FROM_URL_REGEX = /^https?:\/\/[^/]+\/([^/]+)\/.*$/i;
            const match = parsedUrl.match(CLIENT_FROM_URL_REGEX);
            accountDetails.clientName = match ? match[1] : 'default';
            if (accountDetails.clientName === 'default') {
              this.loggerService.error('Client name could not be parsed from the URL.');
            }

            return AccountActions.loadAccountDetailsSuccess({
              accountDetails,
            });
          }),
          catchError((error) => {
            this.loggerService.error('API call failed: ', error);
            return of(AccountActions.loadAccountDetailsFailure({ error }));
          })
        );
      })
    )
  );
}
